import { eventsApi } from '@entities/events/api.ts';
import { EventList } from '@widgets/events/index.ts';
import { PageBackButton } from '@features/common/PageBackButton/index.tsx';
import { useAppSelector } from '@shared/hooks/index.ts';
import { ListBody, PageHead } from '@shared/ui/index.ts';
import { selectTab } from '@src/library/redux/events/index.ts';

export const EventArchivePage = () => {
  const tab = useAppSelector(selectTab);

  return (
    <>
      <PageHead Center={'История'} Left={<PageBackButton />} />
      <ListBody>
        <EventList key={`${tab.code}past`} params={{ bytime: 'past' }} api={eventsApi} />
      </ListBody>
    </>
  );
};
